import React from 'react';
import { MapPin, Video, Shield, Calendar, RefreshCw } from 'lucide-react';
import LotusIcon from './LotusIcon';

const options = [
  { Icon: MapPin, title: 'In-Person in Chesapeake, VA', text: 'Meet with us at our warm, welcoming office.' },
  { Icon: Video, title: 'Telehealth Appointments', text: 'Secure video sessions across Virginia.' },
  { Icon: Shield, title: 'Insurance & Billing Support', text: 'We help you understand your options.' },
  { Icon: Calendar, title: 'Appointment Requests', text: 'Reach out and we’ll find a time that works.' },
  { Icon: RefreshCw, title: 'Existing Client Scheduling', text: 'Easily book your next session online.' },
];

export default function TherapyMeets() {
  return (
    <section className="section-pad relative overflow-hidden" style={{ background: 'var(--cream)' }}>
      <div className="absolute right-0 bottom-0 opacity-20"><LotusIcon className="w-72 h-72" /></div>
      <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
        <div className="text-center mb-10 reveal">
          <div className="eyebrow mb-3">Meeting You Where You Are</div>
          <h2 className="section-title">Therapy That Meets You <span className="text-[color:var(--dusty-rose)]">Where You Are</span></h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5">
          {options.map(({ Icon, title, text }, i) => (
            <div key={title} className="card-soft p-6 text-center reveal" style={{ transitionDelay: `${i * 60}ms` }}>
              <div className="w-12 h-12 rounded-full mx-auto mb-4 flex items-center justify-center serviceCard-icon">
                <Icon className="w-5 h-5 text-[color:var(--dusty-rose)]" strokeWidth={1.5} />
              </div>
              <h4 className="font-serif-display text-base text-[color:var(--deep-sage)] mb-2">{title}</h4>
              <p className="text-xs text-[color:var(--taupe-gray)] leading-relaxed">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
